import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@/lib/ThemeProvider';
import App from '@/App';
import { setupGlobalErrorHandlers } from '@/utils/errorHandlers';
import { getDevAgencyDomain, setDevAgencyDomain } from '@/utils/devAgency';
import { agencyConfigs } from '../configs';
import './styles/globals.css';
setupGlobalErrorHandlers();
if (process.env.NODE_ENV === 'development' && !getDevAgencyDomain()) {
    const first = agencyConfigs[0];
    if (first?.agencyDomain) {
        setDevAgencyDomain(first.agencyDomain);
    }
}
const container = document.getElementById('root');
if (!container) {
    throw new Error('Failed to find the root element');
}
const root = createRoot(container);
root.render(_jsx(ThemeProvider, { children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }));
